import { render, staticRenderFns } from "./common-input.vue?vue&type=template&id=21afe17a&scoped=true&"
import script from "./common-input.vue?vue&type=script&lang=js&"
export * from "./common-input.vue?vue&type=script&lang=js&"
import style0 from "./common-input.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./common-input.vue?vue&type=style&index=1&id=21afe17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21afe17a",
  null
  
)

export default component.exports